module.exports = __webpack_public_path__ + "static/img/fundlawer.792e301.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dymanticLanshu/fundlawer.jpg
// module id = aTMx
// module chunks = 0